export default "__VITE_ASSET__RPZ$pGHc__"